module.exports = __webpack_public_path__ + "static/media/cd-icon-select.654e87a5.svg";